import { useContext } from "react";

import ProposalInputContext from "../../../context/ProposalInputContext";

import Grid from "@mui/material/Grid";
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ClearIcon from '@mui/icons-material/Clear';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const InputFooter = () => {
  const {
    values, setValues, formErrors, randomnessArray, handleSubmit, handleClear
  } = useContext(ProposalInputContext);

  return (
    <>
      <Divider
        sx={{
          width: '100%',
          borderColor: '#e2e8f0',
          borderBottomWidth: '2px',
          my: 1,
        }}
      />

      <Grid size={{ xs: 12 }}>
        <Stack direction="row" spacing={1} justifyContent="space-between">
          <Box>
            <Button
              variant="outlined"
              startIcon={<ClearIcon />}
              onClick={handleClear}
              sx={{
                textTransform: 'none',
                color: '#475569',
                borderColor: '#CBD5E1',
                '&:hover': {
                  borderColor: '#475569',
                  backgroundColor: '#F8FAFC',
                }
              }}
            >
              Clear
            </Button>
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2
            }}
          >
            <Box>
              <Typography
                color="text.secondary"
                sx={{ display: 'flex', alignItems: 'center' }}
              >
                <strong>Randomness</strong>
              </Typography>
            </Box>

            <Box>
              <FormControl fullWidth error={'randomness' in formErrors}>
                <Select
                  labelId="randomness"
                  id="randomness"
                  name="randomness"
                  value={values?.randomness}
                  onChange={e =>
                    setValues(prev => ({
                      ...prev,
                      randomness: e.target.value
                    }))
                  }
                  size="small"
                >
                  {randomnessArray.map((data, index) => (
                    <MenuItem value={data} key={index}>{data}</MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formErrors['randomness']}</FormHelperText>
              </FormControl>
            </Box>

            <Box ml={2}>
              <Button
                variant="contained"
                startIcon={<AutoAwesomeIcon />}
                onClick={handleSubmit}
                sx={{
                  textTransform: 'none',
                  backgroundColor: '#0f172a',
                  '&:hover': {
                    backgroundColor: '#1E293B',
                  },
                }}
              >
                Generate Proposal
              </Button>
            </Box>
          </Box>
        </Stack>
      </Grid>
    </>
  );
};

export default InputFooter;